/* eslint-disable no-return-assign */

const setPagination = (state, action) => {
  const { pagination } = action.payload;
  const parsedData = {};
  Object.keys(pagination).forEach(key => parsedData[key] = parseInt(pagination[key], 10));

  return {
    ...state,
    pagination: {
      ...state.pagination,
      ...parsedData,
    },
  };
};

const setSortBy = (state, action) => ({ ...state, sortBy: action.payload.sortBy });

export default {
  setPagination,
  setSortBy,
};
